import {useEffect} from 'react';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useChekinSDK} from 'context/ChekinSDK';
import {useErrorToast} from 'hooks';
import {API, GuestTokenStorageHandler} from '@chekin/api';
import {usePostHogTrack} from 'analytics';
import {POSTHOG_EVENTS} from 'analytics/posthog';

function useFetchParticipants() {
  const {isSuccessSDK} = useChekinSDK();
  const {trackEvent} = usePostHogTrack();

  const queryData = useQuery({
    queryKey: [QUERY_CACHE_KEYS.participants],
    queryFn: () => API.auth.getParticipants(),
    enabled: isSuccessSDK && Boolean(GuestTokenStorageHandler.getToken()),
  });
  useErrorToast(queryData.error);

  useEffect(() => {
    if (queryData.error) {
      trackEvent(POSTHOG_EVENTS.INSTANT_CHECK_IN_FAILED, {
        failure_reason: 'participants_load_error',
      });
    }
  }, [queryData.error, trackEvent]);

  return queryData;
}

export {useFetchParticipants};
